import type { FunctionComponent } from "react";

const TimelineEmptyMessage: FunctionComponent = () => {
	return <div className="flex items-center justify-center text-sm text-gray-500">Keine Einträge vorhanden</div>;
};

export default TimelineEmptyMessage;